import api from './api';

export type RelatorioFormato = 'pdf' | 'excel';

export interface RelatorioFiltros {
  tipo_produto?: string;
  produto?: string;
  ativo?: string;
  status?: string;
  search?: string;
  localizacao?: string;
  data_inicio?: string;
  data_fim?: string;
}

export interface TipoRelatorio {
  id: string;
  titulo: string;
  formatos: RelatorioFormato[];
  filtros: Array<'tipo_produto' | 'produto' | 'ativo' | 'status' | 'search' | 'localizacao' | 'data'>;
}

export const TIPOS_RELATORIO: TipoRelatorio[] = [
  { id: 'produtos', titulo: 'Relatório de Produtos', formatos: ['pdf', 'excel'], filtros: ['search', 'tipo_produto', 'ativo'] },
  { id: 'ordens', titulo: 'Relatório de Ordens de Produção', formatos: ['pdf'], filtros: ['search', 'produto', 'status', 'data'] },
  { id: 'estoque', titulo: 'Relatório de Estoque', formatos: ['pdf', 'excel'], filtros: ['produto', 'status', 'localizacao', 'search'] },
  { id: 'custos', titulo: 'Relatório de Custos', formatos: ['pdf', 'excel'], filtros: ['search', 'produto', 'status', 'data'] },
];

const ENDPOINT = '/industrializacao/relatorios';

const relatorioService = {
  /**
   * Baixa o relatorio (pdf ou excel) e dispara o download no navegador.
   * NOTA: o backend real (Django/Laravel) so tem endpoints para produtos/ordens/estoque/custos.
   * O card "Qualidade" existente no Vue original chamava um endpoint que nunca existiu no
   * backend (dead-code) e por isso NAO foi portado. "Rastreabilidade" excel exige um lote_id
   * especifico (rota .../rastreabilidade/{lote}/excel), por isso nao entra nesta lista genérica.
   */
  async baixar(tipoId: string, formato: RelatorioFormato, filtros: RelatorioFiltros = {}): Promise<void> {
    const params: Record<string, string> = {};
    Object.entries(filtros).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params[key] = String(value);
      }
    });

    const response = await api.get(`${ENDPOINT}/${tipoId}/${formato}`, { params, responseType: 'blob' });
    const blob = new Blob([response.data]);
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    const ext = formato === 'pdf' ? 'pdf' : 'xlsx';
    link.download = `${tipoId}_${new Date().toISOString().split('T')[0]}.${ext}`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(link.href);
  },
  /** loteId = UUID do lote (rota real usa route-model-binding por id, nao por numero_lote) */
  async baixarRastreabilidadeLote(loteId: string, numeroLote: string): Promise<void> {
    const response = await api.get(`${ENDPOINT}/rastreabilidade/${loteId}/excel`, { responseType: 'blob' });
    const blob = new Blob([response.data]);
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = `rastreabilidade_${numeroLote}.xlsx`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(link.href);
  },
};

export default relatorioService;
